<div class="sign-in-area" [class.dark-theme]="themeService.isDark()">
    <div class="trezo-form mx-auto" [class.component-dark-theme]="themeService.isDark()" [class.component-rtl-enabled]="themeService.isRTLEnabled()">
        <div class="row align-items-center">
            <!-- <div class="col-lg-6 col-md-12 order-2 order-lg-1">
                <div class="form-image">
                    <img src="images/sign-in.jpg" alt="sign-in-image">
                </div>
            </div> -->

            <div class="d-flex justify-content-center align-items-center vh-100">
                <div class="col-lg-6 col-md-12 order-1 order-lg-2">
                    <div class="form-content">
                        <div class="logo">
                            <img src="images/logo/ALU FINAL LOGO-HORIZONTAL2.png" alt="logo" />
                            <!-- <img
                            src="images/white-logo-big.svg"
                            class="d-none"
                            alt="logo"
                        /> -->
                        </div>
                        <div class="title">
                            <h1 class="fw-semibold">Welcome back to AluTrack Suite</h1>
                        </div>
                        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label class="main-label d-block fw-medium text-black">Email Address</label>
                                <input type="text" class="form-control" placeholder="example&#64;gmail.in" id="input-email" formControlName="email" [ngClass]="{
                    'is-invalid': submitted && f['email'].errors,
                  }" />
                                <div class="form-text text-danger" *ngIf="f['email']!.hasError('required') && f['email']!.touched">
                                    Email is required.
                                </div>
                                <div class="form-text text-danger" *ngIf="f['email']!.hasError('email') && f['email']!.touched">
                                    Please enter a valid email address.
                                </div>
                            </div>
                            <div class="form-group position-relative">
                                <label class="main-label d-block fw-medium text-black">Password</label>
                                <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control" placeholder="Type password" formControlName="password" [ngClass]="{
                    'is-invalid': submitted && f['password']!.errors,
                  }" />
                                <button type="button" (click)="togglePasswordVisibility()" class="icon-button p-0 border-0 bg-transparent transition">
                                    <i [ngClass]="isPasswordVisible ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                                </button>
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('required') && f['password']!.touched">
                                Password is required.
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('hasCharacters') && f['password']!.touched">
                                Minimum Password length should be 8 characters.
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('hasUpper') && f['password']!.touched">
                                Password must contain at least one uppercase.
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('hasLower') && f['password']!.touched">
                                Password must contain at least one lowercase.
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('hasNumber') && f['password']!.touched">
                                Password must contain at least one number.
                            </div>
                            <div class="form-text text-danger" *ngIf="f['password']!.hasError('hasSpecialChar') && f['password']!.touched">
                                Password must contain at least one special character.
                            </div>

                            <div class="forgot-password">
                                <a routerLink="/forgot-password" class="text-primary fw-semibold" (click)="onForgotPasswordClick($event)">
                                    Forgot Password?
                                </a>
                            </div>
                            <button type="submit" class="btn-box d-block w-100 border-0 transition fw-medium border-radius">
                                <span class="d-flex align-items-center justify-content-center">
                                    <i class="material-symbols-outlined">login</i>
                                    Sign In
                                </span>
                            </button>
                            <!-- <p class="info">
                                Don’t have an account.
                                <a routerLink="/sign-up" class="fw-semibold text-primary">Sign Up</a>
                            </p> -->

                            <div class="form-group link-danger">
                                <span>{{ error }}</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>